import {requestToBook} from './utils/requestToBook';

function chatbotRequestToBook(store) {
    return requestToBook(store, 'chat bot');
}

export {chatbotRequestToBook};
